<template>
    <a
        :href="this.$root.baseUrl + '/favorites'"
        class="actions-header__item header-favorite"
    >
        <span>{{favoritesIds.complexes.length + favoritesIds.properties.length || ''}}</span>
    </a>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "FavoritesLink",
    computed: {
        ...mapGetters({
            favoritesIds: 'favorites/favoritesIds'
        })
    }
}
</script>


<style>
    .header-favorite::before {
        content: '';
        position: relative;
        width: 24px;
        height: 24px;
        z-index: 3;
        background: url(/img/header/favorite.svg) center center / contain no-repeat;
    }

    .header-favorite:hover::before {
        background: url(/img/header/favorite_hover.svg) center center / contain no-repeat;
    }
</style>